<template>
  <span 
    v-b-tooltip.top.dh0="{customClass: 'iconExpireWarning'}"
    :title="title"
    :key="iconkey"
    style="display:inline-block"
  >
  <svg width="14" height="13" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M13.8422 10.7781C14.2908 11.5557 13.7277 12.5278 12.8316 12.5278H1.16774C0.269968 12.5278 -0.290567 11.5542 0.15719 10.7781L5.98921 0.666282C6.43806 -0.111715 7.56227 -0.110305 8.01031 0.666282L13.8422 10.7781ZM6.99976 8.68748C6.38228 8.68748 5.88171 9.18805 5.88171 9.80554C5.88171 10.423 6.38228 10.9236 6.99976 10.9236C7.61725 10.9236 8.11782 10.423 8.11782 9.80554C8.11782 9.18805 7.61725 8.68748 6.99976 8.68748ZM5.93827 4.66865L6.11857 7.97421C6.127 8.12889 6.25489 8.24998 6.40979 8.24998H7.58973C7.74463 8.24998 7.87253 8.12889 7.88096 7.97421L8.06126 4.66865C8.07037 4.50158 7.93735 4.36109 7.77003 4.36109H6.22947C6.06215 4.36109 5.92915 4.50158 5.93827 4.66865Z" 
      :fill="(expired) ? '#B91C1C' : '#F59E0B'"/>
  </svg>
  </span>
</template>

<script>
    export default {
        name: "IconExpireWarning",
        props: ['iconkey','title','expired']
    }
</script>

<style lang="css">
  .iconExpireWarning.tooltip{
    opacity: 1 !important;
    top:-3px !important;
  }
  .iconExpireWarning .tooltip-inner {
    background-color: #4B5563 !important;
  }
  .iconExpireWarning.tooltip.bs-tooltip-top .arrow::before, .iconExpireWarning.tooltip.bs-tooltip-auto[x-placement^="top"] .arrow::before {
    border-top-color: #4B5563 !important;
  }
</style>